

import { useState } from 'react';
import Button from '../../../components/button';
import { apiCheckInfo } from '@/api';
import { LoadingMask, showToast } from '@/utils/utils';
interface Props {
    onCancel?: (e: any) => void;
}
export default function Certification({ onCancel }: Props) {
    // 取url中iccid的参数
    const urlParams = new URLSearchParams(window.location.search);
    const iccid = urlParams.get('iccid') || '';
    const [name, setName] = useState('');
    // 王子旭 412825199608235319
    const [cardNo, setcardNo] = useState('');
    async function onOk() {
        if (!name) {
            return showToast('请输入姓名');
        } else if (!cardNo) {
            return showToast('请输入身份证号');
        }
        LoadingMask.show('正在验证...');
        const res = await apiCheckInfo({ name, cardNo, iccid })
        if (res.data?.data?.code === 0) {
            onCancel && onCancel(true)
            showToast('校验通过，请进行下一步')
        } else if (res.data?.data?.code === 60002) {
            showToast(res.data?.data?.msg)
            onCancel && onCancel(false)
        } else {
            showToast(res.data?.data?.msg)
        }
        LoadingMask.hide();
    }

    return (
        <div className='pt-0 pb-20 pl-20 pr-20 certification'>
            <div className='w-102 h-90 pos-r' style={{ margin: '0 auto' }}>
                <img src="/pic/certification/user.png" alt="" className='pos-a' style={{ width: 80, height: 80, top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }} />
                <img src="/pic/certification/certification.png" alt="" className='pos-a' style={{ width: 62, height: 20, top: '88%', left: '58%', transform: 'translate(-50%,-50%)' }} />
            </div>
            <div className='pos-r  h-250'>
                <img src="/pic/cert.png" alt="" className='pos-a' style={{ width: 300, height: 250, top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }} />
            </div>
            <div className='text-center '>
                <div className="font-size-16 font-widget-600">请验证您的真实身份</div>
                <div className="font-size-14 pt-8" style={{ color: '#9E9E9E' }}> 为保障您的账户安全，避免身份信息被盗用，</div>
                <div className="font-size-14 pt-8" style={{ color: '#9E9E9E' }}> 绑卡前请完成实名认证，我们承诺保护您的信息安全</div>

            </div>
            <div className='box '>
                <div className="mt-10 mb-10 d-flex-r font-size-14 border-bottom pb-6">
                    <div className="w-90"> 姓名：</div>
                    <input
                        className="flex-1 font-size-14 input-style pb-10"
                        type="text"
                        value={name}
                        placeholder="请输入您实名人姓名"
                        onChange={(e) => setName(e.currentTarget.value)}
                    />
                </div>
                <div className="mt-15 mb-10 d-flex-r font-size-14 border-bottom pb-6">
                    <div className="w-90"> 身份证号：</div>
                    <input
                        className="flex-1 font-size-14 input-style pb-10"
                        type="text"
                        value={cardNo}
                        placeholder="请输入实名人身份证号"
                        onChange={(e) => setcardNo(e.currentTarget.value)}
                    />
                </div>

            </div>

            <Button type="primary" className='button-primary mt-30' size="lg" shape="circle" long onClick={() => onOk()}>
                开始认证
            </Button>
        </div>
    );
}
